/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';

/**
 * Representation of a Product List
 * @export
 * @interface ProductList
 */
export interface ProductList {
    /**
     * List of products
     * @type {Array<Product>}
     * @memberof ProductList
     */
    products?: Array<Product>;
    /**
     * Catalog of product list
     * @type {string}
     * @memberof ProductList
     */
    catalog?: string;
    /**
     * Version of product list
     * @type {string}
     * @memberof ProductList
     */
    version?: string;
    /**
     * Total product count
     * @type {number}
     * @memberof ProductList
     */
    totalProductCount?: number;
    /**
     * Total page count
     * @type {number}
     * @memberof ProductList
     */
    totalPageCount?: number;
    /**
     * Number of current page
     * @type {number}
     * @memberof ProductList
     */
    currentPage?: number;
}

/**
 * Check if a given object implements the ProductList interface.
 */
export function instanceOfProductList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductListFromJSON(json: any): ProductList {
    return ProductListFromJSONTyped(json, false);
}

export function ProductListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'products': !exists(json, 'products') ? undefined : ((json['products'] as Array<any>).map(ProductFromJSON)),
        'catalog': !exists(json, 'catalog') ? undefined : json['catalog'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'totalProductCount': !exists(json, 'totalProductCount') ? undefined : json['totalProductCount'],
        'totalPageCount': !exists(json, 'totalPageCount') ? undefined : json['totalPageCount'],
        'currentPage': !exists(json, 'currentPage') ? undefined : json['currentPage'],
    };
}

export function ProductListToJSON(value?: ProductList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'products': value.products === undefined ? undefined : ((value.products as Array<any>).map(ProductToJSON)),
        'catalog': value.catalog,
        'version': value.version,
        'totalProductCount': value.totalProductCount,
        'totalPageCount': value.totalPageCount,
        'currentPage': value.currentPage,
    };
}

